module.exports = __webpack_public_path__ + "img/icon-chevron-down.5ce68e0c.svg";